import React from 'react';
// import React, { useState } from 'react';
import Hero from './components/hero/Hero';
// import Projects from './components/projects/Projects';
import Contact from './components/contact/Contact';
import './App.css';

// interface Project {
//   id: number;
//   title: string;
//   description: string;
//   image: string;
//   demoLink: string;
//   githubLink: string;
//   longDescription?: string;
//   technologies?: string[];
// }

const App: React.FC = () => {
  // const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  return (
    <div>
      <main className="main-content">
        <Hero />
        {/* <Projects selectedProject={selectedProject} setSelectedProject={setSelectedProject} /> */}
        <div className="building-message">
          <p className="text-center text-xl font-semibold text-gray-600 my-12">
            🚧 Portfolio under construction - Exciting projects coming soon! 🚧
          </p>
        </div>
        <Contact />
      </main>
    </div>
  );
};

export default App;